// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"bbc99f0b","977":"f585f6e4"}[chunkId] + ".chunk.js";
};